import { render, staticRenderFns } from "./defaultEva.vue?vue&type=template&id=664c8b34&scoped=true&"
import script from "./defaultEva.vue?vue&type=script&lang=js&"
export * from "./defaultEva.vue?vue&type=script&lang=js&"
import style0 from "./defaultEva.vue?vue&type=style&index=0&id=664c8b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c8b34",
  null
  
)

export default component.exports